(() => {
  const TARGET_PATH = '/products/naija-1960-mesh-jersey';
  if (!window.location.pathname.startsWith(TARGET_PATH)) return;

  const normalize = (value) => (value || '').trim().toLowerCase();

  function getSelectedColor() {
    const picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return null;

    const checked = picker.querySelector('input[name="Color"]:checked, input[name="options[Color]"]:checked');
    if (checked?.value) return normalize(checked.value);

    const select = picker.querySelector('select[name="Color"], select[name="options[Color]"]');
    if (select?.value) return normalize(select.value);

    return null;
  }

  function getMediaColor(item) {
    const img = item.querySelector('img');
    const alt = normalize(img?.getAttribute('alt'));
    const src = normalize(img?.currentSrc || img?.src);
    const text = `${alt} ${src}`;

    if (text.includes('green') && (text.includes('naija') || text.includes('1960') || text.includes('mesh-jersey') || text.includes('mesh jersey'))) return 'green';
    if (text.includes('white') && (text.includes('naija') || text.includes('1960') || text.includes('mesh-jersey') || text.includes('mesh jersey'))) return 'white';
    return null;
  }

  function activateFirstMatching(gallery, thumbnails, mediaItems, color) {
    const firstMatching = mediaItems.find((item) => !item.hidden && getMediaColor(item) === color);
    if (!firstMatching) return;

    const mediaId = firstMatching.dataset.mediaId;
    try {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        return;
      }

      const thumb = thumbnails?.querySelector(`[data-target="${CSS.escape(mediaId)}"] button`);
      if (thumb) {
        thumb.click();
        return;
      }

      mediaItems.forEach((item) => item.classList.toggle('is-active', item === firstMatching));
      firstMatching.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    } catch (error) {
      console.debug('CLTD Naija gallery activation retry', error);
    }
  }

  function applyToGallery(gallery, color) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    const mediaItems = [...viewer.querySelectorAll('[data-media-id]')];
    if (!mediaItems.length) return;

    const coloredItems = mediaItems.filter((item) => getMediaColor(item) === color);

    // Do not blank the gallery if the selected color assets are not present yet.
    if (!coloredItems.length) return;

    mediaItems.forEach((item) => {
      item.classList.remove('product__media-item--variant');
      const itemColor = getMediaColor(item);
      const show = itemColor === color;
      item.hidden = !show;
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
      item.style.setProperty('display', show ? '' : 'none', show ? '' : 'important');
      if (show) item.style.removeProperty('display');
    });

    if (thumbnails) {
      thumbnails.querySelectorAll('.thumbnail-list_item--variant').forEach((thumb) => thumb.classList.remove('thumbnail-list_item--variant'));
      [...thumbnails.querySelectorAll('[data-target]')].forEach((thumb) => {
        const linkedMedia = mediaItems.find((item) => item.dataset.mediaId === thumb.dataset.target);
        const show = !!linkedMedia && !linkedMedia.hidden;
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) thumb.style.removeProperty('display');
        else thumb.style.setProperty('display', 'none', 'important');
      });
    }

    activateFirstMatching(gallery, thumbnails, mediaItems, color);

    if (viewer.slider?.resetPages) viewer.slider.resetPages();
    if (thumbnails?.slider?.resetPages) thumbnails.slider.resetPages();
  }

  function applyColorGallery() {
    const color = getSelectedColor();
    if (!['green', 'white'].includes(color)) return;
    document.querySelectorAll('media-gallery').forEach((gallery) => applyToGallery(gallery, color));
  }

  function scheduleApply() {
    [0, 80, 220, 500].forEach((delay) => window.setTimeout(applyColorGallery, delay));
  }

  function bind() {
    scheduleApply();

    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-radios, variant-selects')) scheduleApply();
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('variant-radios, variant-selects')) scheduleApply();
    });

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('media-gallery, variant-radios, variant-selects') || node.querySelector?.('media-gallery, variant-radios, variant-selects'))))) {
        scheduleApply();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();